import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_EPISODE_EXPANDER]: 'Show all {episodeCount} episodes',
}